import { GridList, GridListTile, makeStyles } from "@material-ui/core";
import React from "react";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: "0.5rem",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-around",
    overflow: "hidden",
    backgroundColor: theme.palette.background.paper,
  },
  gridList: {
    width: "100%",
  },
  image: {
    objectFit: "cover",
    width: "100%",
    height: "100%",
  },
}));

const ImageMosaic = ({ images }) => {
  const classes = useStyles();
  console.log(images);
  return images ? (
    <div className="image-mosaic">
      <div className={`image-mosaic__content ${classes.root}`}>
        <GridList
          cellHeight={430}
          cols={4}
          className={`image-mosaic__content__gridlist ${classes.gridList}`}
        >
          {images.map((image, index) => (
            <GridListTile
              className="image-mosaic__content__gridlist__tile"
              key={image.img}
              cols={parseInt(image.cols)}
              rows={parseInt(image.rows)}
            >
              <img
                className={classes.image}
                src={image.img}
                alt={`image-${index}`}
              />
            </GridListTile>
          ))}
        </GridList>
      </div>
    </div>
  ) : null;
};

export const COL_MAXMIN = { min: 2, max: 9 };
export const ROW_MAXMIN = { min: 1, max: 2 };

export default ImageMosaic;
